import { Suspense } from "react";
import { createBrowserRouter, Navigate, RouterProvider, useLocation } from "react-router";
import { MODULE } from "./modules";
import { routeErlaubt } from "./kern/navigation";
import type { Recht } from "./kern/rechte";
import { routenAus } from "./kern/routen";
import { useSitzung } from "./kern/sitzung";
import { Shell } from "./kern/shell/Shell";
import { Anmelden } from "./kern/seiten/Anmelden";
import { Datenschutz } from "./kern/seiten/Datenschutz";
import { Willkommen } from "./kern/seiten/Willkommen";
import { KeinRecht, KeinZugang, Laden, NichtGefunden, Offline, OhneDatenbank } from "./kern/seiten/Hinweisseiten";
import { Laedt } from "./kern/ui/Laedt";

/** Hinter der Anmeldung: nur aktive Personen. Erste Anmeldung führt zuerst zu „Willkommen“. */
function Geschuetzt() {
  const { sitzung } = useSitzung();
  const ort = useLocation();
  switch (sitzung.status) {
    case "laedt":
      return <Laden />;
    case "ohne_datenbank":
      return <OhneDatenbank />;
    case "abgemeldet":
      return <Navigate to="/anmelden" replace state={{ von: ort.pathname }} />;
    case "offline":
      return <Offline />;
    case "kein_zugang":
      return <KeinZugang email={sitzung.email} />;
    case "angemeldet":
      if (!sitzung.person.erste_anmeldung_am && ort.pathname !== "/willkommen") return <Navigate to="/willkommen" replace />;
      return <Shell module={MODULE} />;
  }
}

function MitRecht({ recht, children }: { recht: Recht | undefined; children: React.ReactNode }) {
  const { sitzung } = useSitzung();
  if (sitzung.status !== "angemeldet") return null;
  // Redaktion, Zugänge und Sitzungen laden erst beim Öffnen (React.lazy, BAUPLAN-PAKETE.md, Abschnitt 5.7)
  return routeErlaubt(recht, sitzung.rechte) ? <Suspense fallback={<Laedt />}>{children}</Suspense> : <KeinRecht />;
}

function AnmeldenSeite() {
  const { sitzung } = useSitzung();
  if (sitzung.status === "ohne_datenbank") return <OhneDatenbank />;
  return <Anmelden />;
}

const router = createBrowserRouter([
  { path: "/anmelden", element: <AnmeldenSeite /> },
  // Öffentlich, auch ohne Anmeldung (BAUPLAN-ABSCHLUSS.md, Abschnitt 8)
  { path: "/datenschutz", element: <Datenschutz /> },
  {
    element: <Geschuetzt />,
    children: [
      { path: "/willkommen", element: <Willkommen /> },
      ...routenAus(MODULE).map((r) => ({
        path: r.pfad,
        element: (
          <MitRecht recht={r.recht}>
            <r.seite />
          </MitRecht>
        ),
      })),
      { path: "*", element: <NichtGefunden /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
